import { render, staticRenderFns } from "./ModalConfirmBlockUser.vue?vue&type=template&id=72146c35"
import script from "./ModalConfirmBlockUser.vue?vue&type=script&lang=js"
export * from "./ModalConfirmBlockUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports